import React from 'react';
import _ from 'lodash';
import { array, bool } from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
const { API } = require('../../config/' + process.env.REACT_APP_ENV);

const PharmacyList = ({ cardSelectorPharmacies, isSinglecare }) => {
  const filteredPharmacy = _.filter(cardSelectorPharmacies, pharmacy => {
    if (
      (API.ALLOW_NAVITUS && !pharmacy.internalPharmacy) ||
      pharmacy.internalPharmacy
    ) {
      return pharmacy;
    }
  });

  return (
    <ul className="pharmacy-lists">
      {!_.isEmpty(filteredPharmacy) &&
        _.map(filteredPharmacy, pharmacy => {
          return (
            <li className="pharmacy-items" key={pharmacy.slug}>
              <a
                href={
                  isSinglecare
                    ? pharmacy.slug
                    : pharmacy.slug.split('/').reverse()[0]
                }
                aria-label={pharmacy.logoAltTextForPharmacy}
                className="themeFocus"
              >
                <div className="pharmacy-logos">
                  <LazyLoadImage
                    alt={pharmacy.logoAltTextForPharmacy}
                    srcSet={pharmacy.logo}
                    src={pharmacy.logo}
                    threshold={10}
                    height="55px"
                    width="173px"
                  />
                </div>
              </a>
            </li>
          );
        })}
    </ul>
  );
};

PharmacyList.propTypes = {
  cardSelectorPharmacies: array,
  isSinglecare: bool
};

export default PharmacyList;
